export enum UserStatus
{
  Undefined=0,
  InProgress ,
  NotProvisioned,
  Provisioned
}
